const styles = theme => ({
  root: {
    // marginTop:70
    marginBottom:20
  },
});

export default styles;